import styled from "styled-components";
import colours from "styles/colours";

export const IrisPageFrame = styled.div`
  box-shadow: inset 1px 0 0 ${colours.elexonBlue};
  padding-left: 8px;
  margin-top: 3rem;
`;

export const IrisBlueDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${colours.elexonBlue};
  margin: 24px 0;
`;
